import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as yup from 'yup';
import { Formik } from 'formik';
import Typography from '@mui/material/Typography';
import { closePopup } from '../../actions/uiActions';
import { resetUserPassword } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class ResetPassword extends React.Component {

    state = {
        newPW: "",
        confirmNewPW: "",
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.resetUserPassword(this.props.userID, this.state.newPW, this.state.confirmNewPW)
    }

    changeText = (event, str) => {
        event.preventDefault()
        this.setState({ [str]: event.target.value })
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    {'Reset Password for '}
                    {this.props.userList.find(x => x.id === this.props.userID).userName}
                    {' '}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Formik
                            initialValues={{
                                password: '',
                                confirmpassword: ''
                            }}
                            validationSchema={yup.object().shape({
                                password: yup
                                    .string()
                                    .required('Required')
                                    .matches(
                                        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
                                        'Must Contain 6 Characters, One Uppercase, One Lowercase, One Number and one special case Character'
                                    ),
                                confirmpassword: yup
                                    .string()
                                    .required('Requird')
                                    .equals([yup.ref('password')], "Password don't match")
                            })}
                        >
                            {({
                                values,
                                handleChange,
                                errors,
                                setFieldTouched,
                                touched,
                            }) => (
                                <form>
                                    <div className="passwordResetbox">
                                        <input
                                            type="text"
                                            placeholder="New Password"
                                            className="myInput"
                                            value={values.password}
                                            onChange={handleChange('password')}
                                            onBlur={() => setFieldTouched('password')}
                                            onChangeCapture={(event) => this.changeText(event, "newPW")}
                                        />
                                        {errors.password && touched.password && (
                                            <Typography className="loginError">
                                                {errors.password}
                                            </Typography>
                                        )}
                                        <input
                                            type="text"
                                            placeholder="Confirm Password"
                                            className="myInput"
                                            value={values.confirmpassword}
                                            onChange={handleChange('confirmpassword')}
                                            onBlur={() => setFieldTouched('confirmpassword')}
                                            onChangeCapture={(event) => this.changeText(event, "confirmNewPW")}
                                        />
                                        {errors.confirmpassword && touched.confirmpassword && (
                                            <Typography className="loginError">
                                                {errors.confirmpassword}
                                            </Typography>
                                        )}
                                        <button
                                            type="submit"
                                            className="btn"
                                            onClick={(e) => this.handleSubmit(e)}
                                        >
                                            Submit
                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        userID: state.ui.popupInfo,
        userList: state.users.data,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, resetUserPassword }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)